import React from 'react'
import ReactDOM from 'react-dom'
import { Button } from '@workboard/wobo-ui'
import styled from 'styled-components'
import FileUploadComp from './fileUploadComp'
import AddITemModal from '../modals/addItemModal'
import MeetingServices from '../../services/meeting.services'

export const StyledButton = styled(Button)`
  min-width: 32px;
  height: 32px;
  padding: 0;
  position: relative;
`
class MeetingTabButton extends React.Component {
  constructor(props) {
    super(props)
    let fromWhere = null
    const currentAddressBarUrl = window.location.href
    if (
      typeof currentAddressBarUrl !== 'undefined' &&
      currentAddressBarUrl.indexOf('from_where=msteams') != -1
    ) {
      fromWhere = 'msteams'
    }
    this.state = {
      popupelement: '',
      isUpload: false,
      enOtherSource: false,
      fromWhere,
    }
    this.meetingServices = new MeetingServices()
    this.hideTimeoutId = null
    this.viewPopup = this.viewPopup.bind(this)
    this.closePopup = this.closePopup.bind(this)
    this.clickOtherSource = this.clickOtherSource.bind(this)
    this.showOtherSource = this.showOtherSource.bind(this)
    this.hideOtherSource = this.hideOtherSource.bind(this)
  }

  viewPopup(e) {
    e.preventDefault()
    const _this = this
    const { props } = this
    const { id, url = '' } = props

    if (id == 'attachment') {
      this.setState({ isUpload: true })
    } else {
      if (url) {
        showLoaderWidget($('#content'))
        this.meetingServices.searchresults(url).then((resp) => {
          let resItems = []
          let totalCount = resp.data?.totalCount || 0
          let aiType = null;
          if (id == 'workstream') {
            resItems = resp.data.ws || []
          } else if (id == 'objective') {
            resItems = resp.data.goals || []
          } else if (id == 'key_result') {
            resItems = resp.data.metrics || []
          } else if (id == 'ai') {
            aiType = 0;
            if (
              window.wbConfig.isNewMeetingsEnabled &&
              !url.includes('search/activity')
            ) {
              resItems = resp.data.data || []
            } else {
              resItems = resp.data.ais || []
            }
          } else if (id == 'onenote') {
            resItems = resp.data.data || []
          } else if (id == 'last_meeting_actions') {
            resItems = resp.data.data || []
          }
          removeLoader()
          ReactDOM.render(
            <AddITemModal
              key={`meet_item_popup_${id}`}
              url={url}
              aiType={aiType}
              {...props}
              items={resItems}
              totalCount={totalCount}
              closePopup={_this.props.closePopup}
              addItem={props.addItem}
            />,
            document.getElementById('meeting-add-popup-wrapper')
          )
        })
      } else {
        this.closePopup()
      }
    }
  }

  closePopup() {
    const popupelement = $(meetingAddPopupWrapper)
    if (popupelement != '') {
      ReactDOM.unmountComponentAtNode(
        document.getElementById('meeting-add-popup-wrapper')
      )
      $(popupelement).dialog('close')
    }
  }

  showOtherSource() {
    // Clear any pending hide timeout to prevent race condition
    if (this.hideTimeoutId !== null) {
      clearTimeout(this.hideTimeoutId);
      this.hideTimeoutId = null;
    }
    this.setState({
      enOtherSource: true,
    })
  }

  hideOtherSource() {
    this.setState({
      enOtherSource: false,
    })
  }

  clickOtherSource() {
    const { enOtherSource } = this.state
    this.setState({
      enOtherSource: !enOtherSource,
    })
  }

  componentWillUnmount() {
    // Clean up any pending timeout to prevent memory leaks
    if (this.hideTimeoutId !== null) {
      clearTimeout(this.hideTimeoutId);
      this.hideTimeoutId = null;
    }
  }

  render() {
    const { props } = this

    return (
      <div>
        {props.id == 'attachment' ? (
          <div
            onMouseEnter={this.showOtherSource}
            onMouseLeave={(e) => {
              // Delay hiding to allow click to register
              // Clear any existing timeout before setting a new one
              if (this.hideTimeoutId !== null) {
                clearTimeout(this.hideTimeoutId);
              }
              this.hideTimeoutId = setTimeout(() => {
                this.hideOtherSource();
                this.hideTimeoutId = null;
              }, 200);
            }}
            onClick={(e) => {
              // Prevent the menu from closing immediately
              e.stopPropagation();
            }}
          >
            <StyledButton
              title={props.title}
              className={`meeting-btn-wrap clickable ${props.id}`}
              onClick={this.clickOtherSource}
              
            >
              <div
                className="meeting-btn-icon left"
                id={props.id}
                data-testid="meeting-btn-icon"
              />
            </StyledButton>
            <FileUploadComp
              url="meeting/saveMeetingTopicAttachment"
              fromWhere={this.state.fromWhere}
              saveData={{ meeting_id: props.meetingId }}
              showFilenamePopup="1"
              events={props.actions}
              parent={this}
              isUpload={this.state.isUpload}
              currentUser={props.currentUser}
              hoverOtherSourceEn={this.state.enOtherSource}
              boxApiKey={props.boxApiKey}
              dropBoxApiKey={props.dropBoxApiKey}
              refreshLegacyData={props.refreshLegacyData}
              accessToken={props.accessToken}
              appInID={props.appInID}
              isFUSEnabled={props.isFUSEnabled}
              deleteTopicTakeNonTake={props.deleteTopicTakeNonTake}
              msAppId={props.msAppId}
              meetingRedirectUrl={props.meetingRedirectUrl}
            />
          </div>
        ) : (
          <StyledButton
            title={props.title}
            className={`meeting-btn-wrap clickable ${props.id}`}
            onClick={this.viewPopup}
          >
            <div
              className="meeting-btn-icon left"
              id={props.id}
              data-testid="meeting-btn-icon"
            />
          </StyledButton>
        )}
      </div>
    )
  }
}
export default MeetingTabButton
